<template>
  <a
    :href="hit.url"
    class="flex flex-col gap-2 md:gap-3 group lg:col-span-3"
    :aria-label="hit.title"
  >
    <h3 class="text-xl md:text-2xl lg:text-3xl link link--primary font-display">
      {{ hit.title }}
    </h3>

    <span class="text-sm font-semibold">{{ formatDate(hit.dateUpdated) }}</span>

    <div class="prose prose-sm">
      {{ hit.excerpt }}
    </div> 
  </a>
</template>

<script lang="ts">
export default { name: 'DefaultHit' }
</script>

<script setup lang="ts">
import { Hit } from '~/types/Hit'
import { formatDate } from '~/utils/format'

defineProps<{ hit: Hit }>()
</script>

